import { handleActions } from "redux-actions";
import {
    clearProxies,
    getProxies,
    getProxiesSuccess,
    getProxiesError,
    getCountProxiesSuccess,
    getCountProxiesError,
    getCountProxies,
    setAttachExistedTagDialog,
    mergeAttachExistedTagDialog,
    setAttachNewTagDialog,
    mergeAttachNewTagDialog,
    setDetachTagDialog,
    mergeDetachTagDialog,
    setImportProxiesDialog,
    setSelectedProxies,
    setProxyDialog,
    mergeProxyDialog
} from "modules/ProxyManager/services/Proxies/actions";

const initialState = {
    isLoading: false,
    isLoadingCount: false,
    count: 0,
    ids: [],
    proxies: [],
    selectedProxies: [],
    attachExistedTagDialog: {
        isOpen: false,
        selected: [],
        isLoading: false,
        initialValues: { expired_at_timestamp: "" }
    },
    attachNewTagDialog: {
        isOpen: false,
        selected: [],
        isLoading: false,
        initialValues: { expired_at_timestamp: "" }
    },
    detachTagDialog: {
        isOpen: false,
        selected: [],
        isLoading: false,
    },
    createProxyDialog: {
        isOpen: false,
        selected: [],
        isLoading: false,
    },
    importProxiesDialog: {
        isOpen: false,
        isLoading: false,
    }
};

export const proxiesReducer = handleActions(
    {
        [clearProxies]: () => ({ ...initialState }),
        [getProxies]: (state) => ({
            ...state,
            ids: [],
            count: 0,
            proxies: [],
            selectedProxies: [],
            isLoading: true
        }),
        [getProxiesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getProxiesError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [setAttachExistedTagDialog]: (state, { payload }) => ({
            ...state,
            attachExistedTagDialog: {
                ...initialState.attachExistedTagDialog,
                ...payload
            }
        }),
        [mergeAttachExistedTagDialog]: (state, { payload }) => ({
            ...state,
            attachExistedTagDialog: {
                ...state.attachExistedTagDialog,
                ...payload
            }
        }),

        [setAttachNewTagDialog]: (state, { payload }) => ({
            ...state,
            attachNewTagDialog: {
                ...initialState.attachNewTagDialog,
                ...payload
            }
        }),
        [mergeAttachNewTagDialog]: (state, { payload }) => ({
            ...state,
            attachNewTagDialog: {
                ...state.attachNewTagDialog,
                ...payload
            }
        }),

        [setImportProxiesDialog]: (state, { payload }) => ({
            ...state,
            importProxiesDialog: {
                ...initialState.importProxiesDialog,
                ...payload
            }
        }),

        [setDetachTagDialog]: (state, { payload }) => ({
            ...state,
            detachTagDialog: {
                ...initialState.detachTagDialog,
                ...payload
            }
        }),
        [mergeDetachTagDialog]: (state, { payload }) => ({
            ...state,
            detachTagDialog: {
                ...state.detachTagDialog,
                ...payload
            }
        }),

        [getCountProxies]: (state) => ({
            ...state,
            isLoadingCount: true
        }),
        [getCountProxiesSuccess]: (state, { payload }) => ({
            ...state,
            count: payload,
            isLoadingCount: false
        }),

        [setSelectedProxies]: (state, { payload }) => ({
            ...state,
            selectedProxies: payload
        }),

        [getCountProxiesError]: (state) => ({
            ...state,
            isLoadingCount: false
        }),

        [setProxyDialog]: (state, { payload }) => ({
            ...state,
            createProxyDialog: {
                ...initialState.createProxyDialog,
                ...payload
            }
        }),
        [mergeProxyDialog]: (state, { payload }) => ({
            ...state,
            createProxyDialog: {
                ...state.createProxyDialog,
                ...payload
            }
        }),
    },
    initialState
);
